import { createFileRoute, notFound, redirect } from '@tanstack/react-router';
import { softwareFromAppIntegrationQueryOptions } from '@/features/app-integration/query';

/**
 * AppIntegration ルートツリー全体を Software 側へリダイレクトするキャッチオール。
 * `appIntegrationId` から `softwareId` を解決し、サブパス・search・hash を保持したまま
 * `/software/$softwareId/...` に飛ばす。削除済み AppIntegration を踏んだ場合は notFound()
 * で 404 UI に到達することで無限ループを回避する。
 *
 * パス renames:
 * - `/users(/...)` → `/alerts(/...)` (AppInt 側の users タブは Software では alerts)
 * - `/settings/general(/...)` → `/settings/integration(/...)`
 */
export const Route = createFileRoute('/_staff/app-integrations/$id/_$id')({
  beforeLoad: async ({
    params,
    location,
    context
  }) => {
    let software;
    try {
      software = await context.queryClient.ensureQueryData(softwareFromAppIntegrationQueryOptions(params.id));
    } catch {
      throw notFound();
    }
    const appPrefix = `/app-integrations/${params.id}`;
    let suffix = location.pathname.startsWith(appPrefix) ? location.pathname.slice(appPrefix.length) : '';
    suffix = suffix.replace(/^\/users(\/|$)/, '/alerts$1');
    suffix = suffix.replace(/^\/settings\/general(\/|$)/, '/settings/integration$1');

    // searchStr は空または "?key=val..." (先頭に ? を含む)、hash は "#" を含まない値
    const hash = location.hash ? `#${location.hash}` : '';
    const target = `/software/${software.id}${suffix}${location.searchStr}${hash}`;
    throw redirect({
      href: target,
      replace: true
    });
  }
});